import _ from 'lodash'
import { RadioButtonGroup as RadioButtonGroupBase } from 'common-components'

export const ComponentRadioButton = ({ options, onClick, value, disabled, validate, onChange }) => (
  <RadioButtonGroupBase options={options} value={value} onChange={onChange} disabled={disabled} validate={validate} />
)

const RadioButton = (hoc) => {
  const WrappedRadioButton = hoc ? hoc(ComponentRadioButton) : ComponentRadioButton

  return function(props) {
    const { setValue, options, validate, unsetValue, clearValue, value } = props
    const onChange = (value, index) => {
      setValue(options[index])
      clearValue && unsetValue(clearValue)
      validate && validate(true)
    }
    const valueRadioButton = _.get(value, 'value')

    return <WrappedRadioButton {...props} onChange={onChange} value={valueRadioButton} />
  }
}
export default RadioButton
